<div>
    <h2>{{'mantenimientoMarcas.titulo' | translate}}</h2>
    <section class="filters-framed" *ngIf="filtersVisible">
        <form [formGroup]="filtersForm" [ngClass]="{'show-error':showError}">
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'mantenimientoMarcas.filters.nombre' | translate}}</label>
                <input type="text" formControlName="des">
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'mantenimientoMarcas.filters.alias' | translate}}</label>
                <input type="text" formControlName="alias">
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="calendar">
                <label>{{'global.fecha.inicio' | translate}}</label>
                <input [matDatepicker]="fechaInicio" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaInicio"
                    (click)="fechaInicio.open()">
                <mat-datepicker #fechaInicio></mat-datepicker>
              </div>
              <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="calendar">
                <label>{{'global.fecha.fin' | translate}}</label>
                <input [matDatepicker]="fechaFin" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaFin"
                    (click)="fechaFin.open()">
                <mat-datepicker #fechaFin></mat-datepicker>
              </div>
              <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="radio-group move-left">
                <input type="radio" id="insercion" value="false" formControlName="dateType">
                <label for="insercion">{{'global.fecha.insercion' | translate}}</label>
                <input type="radio" id="actualizacion" value="true" formControlName="dateType">
                <label for="actualizacion">{{'global.fecha.actualizacion' | translate}}</label>
            </div>
            <div *ngIf="this.isSmallScreen" class="entry-3-small"></div>
        </form>
    </section>
    <section class="filters-buttons">
        <button *ngIf="!filtersVisible" [ngClass]="{'showFilters': filtersVisible}" (click)="filtersVisible=!filtersVisible"
          title="{{'global.filtros.abrir' | translate}}">
          <i class="fas fa-filter"></i> {{'global.filtros.filtrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary" [ngClass]="{'showFilters': filtersVisible}"
          (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.cerrar' | translate}}">
          <i class="fas fa-times"></i> {{'global.filtros.cerrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary"
          [ngClass]="{'showFilters': filtersVisible, 'secondary-disabled': !checkValuesForm()}" (click)="resetForm()"
          title="{{'global.filtros.limpiar' | translate}}">
          <i class="fas fa-eraser"></i> {{'global.filtros.limpiar' | translate}}
        </button>
        <button *ngIf="filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
          title="{{'global.filtros.filtrar' | translate}}" (click)="filtrar()">
          <i class="fas fa-filter"></i> {{'global.filtros.aplicar' | translate}}
        </button>
    </section>
    <div class="table-wrapper">
      <div class="table-container">
        <table>
          <thead>
              <tr>
                  <th class="icon"></th>
                  <th class="id sortable" (click)="toOrderBy('x=> x.id', 2)">
                    {{'mantenimientoMarcas.table.id' | translate}}
                    <div class="sortable-icons">
                      <i [ngClass]="getIcon('x=> x.id', 2)"></i>
                    </div>
                  </th>
                  <th class="string sortable" (click)="toOrderBy('x=> x.des', 3)">
                    {{'mantenimientoMarcas.table.marca' | translate}}
                    <div class="sortable-icons">
                      <i [ngClass]="getIcon('x=> x.des', 3)"></i>
                    </div>
                  </th>
                  <th class="string sortable" (click)="toOrderBy('x=> x.alias', 4)">
                    {{'mantenimientoMarcas.table.alias' | translate}}
                    <div class="sortable-icons">
                      <i [ngClass]="getIcon('x=> x.alias', 4)"></i>
                    </div>
                  </th>
                  <th class="string sortable sortable-biggest" (click)="toOrderBy('x=> x.GruposEtiquetaMarca.Where(y=>y.GrupoEtiqueta.TipoConfeccionId==1).FirstOrDefault().GrupoEtiqueta.Des', 5)">
                    {{'mantenimientoMarcas.table.grupoCaja' | translate}}
                    <div class="sortable-icons">
                      <i [ngClass]="getIcon('x=> x.GruposEtiquetaMarca.Where(y=>y.GrupoEtiqueta.TipoConfeccionId==1).FirstOrDefault().GrupoEtiqueta.Des', 5)"></i>
                    </div>
                  </th>
                  <th class="string sortable sortable-biggest" (click)="toOrderBy('x=> x.GruposEtiquetaMarca.Where(y=>y.GrupoEtiqueta.TipoConfeccionId==2).FirstOrDefault().GrupoEtiqueta.Des', 6)">
                    {{'mantenimientoMarcas.table.grupoPallet' | translate}}
                    <div class="sortable-icons">
                      <i [ngClass]="getIcon('x=> x.GruposEtiquetaMarca.Where(y=>y.GrupoEtiqueta.TipoConfeccionId==2).FirstOrDefault().GrupoEtiqueta.Des', 6)"></i>
                    </div>
                  </th>
                  <th class="action">
                    <i class="fas fa-plus" (click)="create()" title="{{'mantenimientoMarcas.tituloNew' | translate}}"></i>
                  </th>
              </tr>
          </thead>
          <tbody *ngFor="let marca of marcas; let i = index; trackBy: trackByMarcaId">
              <tr (click)="showDetails(i, marca);" [ngClass]="{'dropdownInfo': dropdownInfo === i}">
                  <td class="icon"><i [ngClass]="dropdownInfo === i ? 'fas fa-angle-down fa-sm' : 'fas fa-angle-right fa-sm'"
                      title="{{dropdownInfo === i ? ('global.minimizarInfo' | translate) : ('global.masInfo' | translate)}}"></i>
                  </td>
                  <td class="id">{{marca.id}}</td>
                  <td class="string">{{marca.des}}</td>
                  <td class="string">{{marca.alias}}</td>
                  <td class="string-longest">{{marca.desGrupoEtiquetaCaja}}</td>
                  <td class="string-longest">{{marca.desGrupoEtiquetaPallet}}</td>
                  <td class="actions">
                      <i class="fas fa-pencil-alt" app-click-stop-propagation (click)="update(marca)" title="{{'titles.editar' | translate}}"></i>
                      <i class="far fa-trash-alt" [ngClass]="{'disabled': marca.registroEnUso}" app-click-stop-propagation (click)="askDelete(marca)" title="{{'titles.eliminar' | translate}}"></i>
                  </td>
              </tr>
              <tr *ngIf="dropdownInfo === i">
                  <td colspan="7">
                      <div class="detail">
                          <div class="title">{{'global.masInformacion' | translate}}</div>
                          <div class="block-inline">
                              <label>{{'mantenimientoMarcas.table.disenyoCaja' | translate}}</label>
                              <p>{{marca.desDisenyoEtiquetaCaja}}</p>
                          </div>
                          <div class="block-inline">
                              <label>{{'mantenimientoMarcas.table.disenyoPallet' | translate}}</label>
                              <p>{{marca.desDisenyoEtiquetaPallet}}</p>
                          </div>
                          <div class="block-inline">
                              <label>{{'global.fecha.insercionShort' | translate}}</label>
                              <p>{{marca.fechaIns | date: 'shortDate' : undefined : defaultLanguage}}</p>
                          </div>
                          <div class="block-inline">
                              <label>{{'global.fecha.actualizacionShort' | translate}}</label>
                              <p>{{marca.fechaUpd | date: 'shortDate' : undefined : defaultLanguage}}</p>
                          </div>
                      </div>
                  </td>
              </tr>
          </tbody>
          <tfoot *ngIf="!marcas || (marcas && marcas.length < 1)">
              <tr>
                <td colspan="12">
                  {{'global.noContent' | translate}}
                </td>
              </tr>
          </tfoot>
        </table>
      </div>
    </div>
    <app-paginator *ngIf="marcas && marcas.length > 0" [itemsPerPage]="itemsPerPage" [currentPage]="currentPage + 1"
        [totalItems]="totalItems" [visiblePages]="visiblePages" (pageChange)="pageChange($event)"
        (itemsPerPageChange)="itemsPerPageChange($event)"></app-paginator>
    <app-toast *ngIf="showError && mensajes" [messages]="mensajes" (closed)="showError=$event"></app-toast>
</div>
<div class="modal" *ngIf="deleteModal">
    <div class="modal-content">
        <header>
            <h4>{{'global.eliminar.descripcion' | translate}}</h4>
        </header>
        <content>
            <p>{{'global.eliminar.confirmacion' | translate}}</p>
        </content>
        <footer>
            <button class="secondary" (click)="close()">{{'global.cancelar' | translate}}</button>
            <button (click)="delete()">{{'global.confirmar' | translate}}</button>
        </footer>
    </div>
</div>
<div class="modal" *ngIf="newEditModal">
    <div class="modal-content">
        <header>
            <h4>{{toEditId ? ('mantenimientoMarcas.tituloEdit' | translate) : ('mantenimientoMarcas.tituloNew' | translate)}}</h4>
        </header>
        <app-mrs-new-edit [marcaId]="toEditId" (refresh)="refresh($event)" (mensaje)="pushMessage($event)"></app-mrs-new-edit>
    </div>
</div>
